export const histLayout = (histogramData, globalMaxBin) => ({
  autosize: true,
  margin: {
    l: 40,
    r: 20,
    b: 80,
    t: 20,
    pad: 0
  },
  xaxis: {
    dtick: 5,
    // Use the global max if available; otherwise fall back to the local maxBin
    range: [0, globalMaxBin || histogramData.maxBin || 10],
    // range: [0, histogramData.maxBin],
    title: 'Value',
    tickangle: 0,
    ticklen: 5,
    tickfont: {
      size: 8
    },
    autorange: false, // prevent Plotly from overriding our range
  },
  yaxis: {
    title: 'Percentage (%)', tickfont: {
      size: 10
    }
  },
})
